import React, { Component } from 'react';
import { withOktaAuth } from "@okta/okta-react";
import queryString from 'query-string';

// components
import Cleared from './Cleared';


export default withOktaAuth(
class Page extends Component {
  _isMounted = false;
  _form = false;

  constructor(props) {
    super(props);
    this.state = { qrcode: '1231' };
    // this.checkUser = checkUser.bind(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    let url = this.props.location.search;
    let params = queryString.parse(url);

    return (
      <>
        <Cleared qrcode={ params.qrcode } />
      </>
    );
  }
}
);